<template>
	<div id="app" :class="{mobileOpen}">
		<transition :name="transition">
			<router-view/>
		</transition>
		<div class="above">
			<div class="mobile-menu" :class="{visible: mobileOpen}">
				<router-link to="/" @click="shareClick('main-mobile-menu')">Главная</router-link>
				<router-link to="/articles" @click="shareClick('articles-mobile-menu')">Интервью</router-link>
				<router-link to="/contest" @click="shareClick('contest-mobile-menu')">Конкурс</router-link>
				<router-link to="/madefor" @click="shareClick('madefor-mobile-menu')">Made for</router-link>
				<uiShares class="mobile-shares" v-if="isMobile"/>
				<router-link to="/madefor" class="madefor-logo" v-if="isMobile">
					<img src="@/assets/madefor_logo.png">
				</router-link>
			</div>

			<div class="mobile-button" @click="openMobileMenu">
				<div class="line"></div>
				<div class="line"></div>
				<div class="line"></div>
			</div>

			<a href="https://lenta.ru" target="_blank" class="lenta-logo" @click="shareClick('lenta-logo')">
				<img src="@/assets/lenta_logo.png">
			</a>
			<div class="back" v-if="canBack" @click="goBack">Назад</div>
			<a
				href="http://made-for.ru/?utm_source=lenta&utm_medium=bottle&utm_campaign=bulleittattoo"
				class="bulleit-logo"
				target="_blank"
				@click="shareClick('bulleit-logo')"
			>
				<img src="@/assets/bulleit_logo.png">
			</a>
			<router-link
				to="/madefor"
				class="madefor-logo"
				@click="shareClick('madefor-logo')"
				v-if="!isMobile"
			>
				<img src="@/assets/madefor_logo.png">
			</router-link>
			<uiShares v-if="!isMobile"/>
		</div>
	</div>
</template>

<script>
import uiShares from '@/components/Shares'

export default {
	components: {
		uiShares,
	},
	data() {
		return {
			mobileOpen: false
		}
	},
	computed: {
		canBack() {
			if (this.$route.name === 'home') return false
			return true
		},
		transition() {
			if (!this.isMobile) return 'fade'
			return ''
		},
		isMobile() {
			return window.innerWidth < 900
		},
	},
	watch: {
		$route() {
			window.scrollTo(0,0)
			this.mobileOpen = false
		}
	},
	methods: {
		goBack() {
			this.shareClick('Назад')
			this.$router.back()
		},
		openMobileMenu() {
			this.mobileOpen = !this.mobileOpen
			this.shareClick('mobile-menu')
		},
		shareClick(type) {
			ga('send', 'event', 'button', type + ' at ' + this.$route.name)
		},
	},
}
</script>


<style lang="less">
@import "./styles.less";

body {
	margin: 0;
	padding: 0;
	outline: none;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	font-family: "PT Serif", serif;
	background: #000;
}

footer,
header,
img,
nav,
section {
	display: block;
}

a {
	text-decoration: none;
}

a.link {
	color: #000;
	text-decoration: underline;
}

#app {
	width: 100vw;
	height: 100vh;
	min-height: 100vh;
	text-align: center;
	color: #fff;
	-webkit-overflow-scrolling: touch;

	&.mobileOpen {
		overflow: hidden;
	}
}

.lenta-logo {
	position: absolute;
	left: 40px;
	top: 40px;
	z-index: 100;

	img {
		width: 117px;
	}
}

.back {
	position: absolute;
	left: 55px;
	top: 70px;
	text-transform: uppercase;
	color: #fff;
	text-decoration: underline;
	font-size: 13px;
	font-family: "Roboto Condensed", sans-serif;
	padding: 20px;
	cursor: pointer;
	opacity: 0.7;
	transition: opacity 300ms ease;
	z-index: 100;

	&:hover {
		opacity: 1;
	}
}

.bulleit-logo {
	position: absolute;
	top: 40px;
	right: 40px;
	z-index: 100;
}

.madefor-logo {
	position: absolute;
	bottom: 40px;
	left: 40px;
	z-index: 100;

	img {
		width: 76px;
	}
}

.mobile-button {
	display: none;
}

.mobile-menu {
	display: none;
}

.mobile-shares {
	display: none;
}

@media (max-width: 900px) {
	.lenta-logo {
		position: absolute;
		left: 20px;
		top: 30px;

		img {
			width: 80px;
		}
	}

	.bulleit-logo {
		position: absolute;
		top: 12px;
		right: 20px;

		img {
			width: 20px;
		}
	}

	.back {
		display: none;
	}

	.madefor-logo {
		bottom: 0px;
		left: 20px;
	}

	.mobile-button {
		width: 30px;
		height: 26px;
		left: 50%;
		top: 20px;
		position: absolute;
		display: block;
		display: flex;
		flex-direction: column;
		justify-content: space-between;
		z-index: 100;

		.line {
			width: 100%;
			height: 3px;
			background: #fff;
		}
	}

	.mobile-menu {
		display: block;
		position: absolute;
		width: 100vw;
		height: 100vh;
		top: 0;
		left: 0;
		background: @color-main;
		display: flex;
		justify-content: center;
		flex-direction: column;
		transform: translateX(-100vw);
		transition: all 500ms ease;
		z-index: 100;

		&.visible {
			transform: translateX(0);
		}

		a {
			color: #000;
			text-transform: uppercase;
			font-family: @font-title;
			font-size: 40px;
			font-weight: bold;
			margin: 15px 0;
		}
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.4s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>
